import { ability } from '@/plugins/casl/ability'

/**
 * Override canNavigate dari @layouts/plugins/casl.js
 *
 * FIX: Route tanpa meta.action/subject = bebas akses untuk user yang sudah login.
 * Jangan panggil ability.can(undefined, undefined) karena itu selalu false
 * untuk user tanpa wildcard 'manage all' (mis. kasir).
 *
 * Regresi Modul C: sengaja import instance `ability` singleton langsung,
 * BUKAN `useAbility()` dari @casl/vue. `useAbility()` pakai Vue inject(),
 * yang butuh "current active instance" context — konteks itu TIDAK bertahan
 * setelah `await` di dalam router guard (guards.js beforeEach sekarang
 * async), jadi canNavigate() dipanggil dari luar context yang valid dan
 * crash "Cannot inject Ability instance". Import langsung aman karena
 * `ability` cuma object biasa (createMongoAbility()), tidak butuh DI sama
 * sekali — sama instance-nya dengan yang di-provide ke abilitiesPlugin.
 */
export const canNavigate = to => {
  // Get the most specific route (last one in the matched array)
  const targetRoute = to.matched[to.matched.length - 1]

  // If the target route has specific permissions, check those
  if (targetRoute?.meta?.action && targetRoute?.meta?.subject)
    return ability.can(targetRoute.meta.action, targetRoute.meta.subject)

  // ✅ FIX: Route tanpa meta.action/subject = tidak ada restriksi khusus,
  // boleh diakses siapa pun yang sudah lolos tahap "isLoggedIn"
  return true
}
